import { Component, OnInit, Input } from '@angular/core';
import { FiltrosFormatoAsistencialEntity, NodoEntity,
  FormatoAsistencialEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-formula',
  templateUrl: './formula.component.html',
  styleUrls: ['./formula.component.css']
})
export class FormulaComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  loading: boolean;
  variables: any[] = [];
  totales: any[] = [];

  filasVariables: any[] = [];

  private HEADERS = new HttpHeaders ({ 'Content-Type' : 'application/json'});

  constructor(private http: HttpClient, private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  async onProcess() {
    this.variables = [];
    this.totales = [];
    this.loading = true;
    this.titulo = this.nodo.titulo || '';
    this.servicioFormato.setTemporalWait(this.nodo, true);
    const url = `${environment.API_REPORTES}/formato-asistencial/formula2`;
    const body: any = {
      codigoBaseDatos : this.filtros.codigoBaseDatos,
      tta: this.filtros.tta,
      nodo : {
        id : this.nodo.id
      }
    };

    const request = await this.http.post(url, body, { headers : this.HEADERS});
    if (request) {
      request.subscribe((response: { hijos: any[], totales: any}) => {
       this.variables = response.hijos;
       this.totales = response.totales;
       this.groupVariables(this.variables);
       this.loading = false;
       this.servicioFormato.setTemporalWait(this.nodo, false);
       if (this.filtros.diligenciados) {
        const validateEmpty = this.validateEmptyResponse(response);
        if (validateEmpty) {
          this.onDelete();
        }
       }
      }, (err: HttpErrorResponse) => {
        console.error(`Error Formula (${this.nodo.id})`, err);
        this.loading = false;
        this.servicioFormato.setTemporalWait(this.nodo, false);
      });
    }
  }

  canShowValue(v: any) {
    return v && v !== 'null';
  }

  /**
   * Método encargado de realizar la validación de pregunta diligenciada.
   * @param response 
   * @returns 
   */
  validateEmptyResponse(response: { hijos: any[], totales: any[]}): boolean {
    let isEmpty = true;
    
    if (response) {
      if (response.hijos) {
        response.hijos.forEach((h: { titulo: string, valor: string}) => {
          if (h.valor && h.valor !== 'null' && h.valor !== '0' && h.valor !== '0.0') {
            isEmpty = false;
          }
        });
      }
  
      if (response.totales) {
        response.totales.forEach((h: { titulo: string, valor: string}) => {
          if (h.valor && h.valor !== 'null' && h.valor !== '0' && h.valor !== '0.0') {
            isEmpty = false;
          }
        });
      }
    }
    return isEmpty;
  }

  onDelete() { }

  groupVariables(vars: any[]) {
    const result = [];
    let counter = 0;

    if (vars && vars.length > 0) {
      vars.forEach((v: any) => {
        const row = result[counter];
        if (row) {
          row.child.push(v);
          counter++;
        } else {
          const newRow = {
            order : counter,
            child : [ v ]
          };
          result.push(newRow);
        }
      });
    }
    this.filasVariables = result;
  }

}
